import { TemplateOrientations } from '@site-mate/dashpivot-shared-library';

export const PrefilledTextFieldCharacterLimit = {
  [TemplateOrientations.Landscape]: 35,
  [TemplateOrientations.Portrait]: 24,
};
